export default __webpack_public_path__ + "static/media/merge.4522c8d7.svg";